export const calculateTan = deg => Math.tan((deg * Math.PI) / 180)
